import {
  SupplementalDataTypes,
  TaskResponse,
  PropertyTypeEnum,
  PriorityLevel,
  Cat,
} from '@dispatch/shared/types';

export const mockDetailsTestData: TaskResponse = {
  tenantId: 'allstate',
  id: 'T_1',
  $relatedTasks: [
    {
      id: 'Related Task_2',
      claimNumber: 'Related Task_2',
      appointment: '2021-12-27T02:48:54-08:00',
      taskReceived: '2021-12-27T11:48:54+01:00',
      assignedResourceId: 'f92ff27e-dba2-4568-a277-379219660810',
      targetQueue: 'dispatched_q',
      methodOfInspection: 'FIELD',
      taskType: {
        type: 'CLAIM_OWNER',
        friendlyName: 'Claim Owner Task',
      },
    },
    {
      id: 'Related Task_3',
      claimNumber: 'Related Task_3',
      appointment: '2021-12-27T02:48:54-08:00',
      taskReceived: '2021-12-27T11:48:54+01:00',
      assignedResourceId: 'f92ff27e-dba2-4568-a277-379219660810',
      targetQueue: 'dispatched_q',
      methodOfInspection: 'FIELD',
    },
    {
      id: 'Related Task_4',
      claimNumber: 'Related Task_4',
      appointment: '2021-12-27T02:48:54-08:00',
      taskReceived: '2021-12-27T11:48:54+01:00',
      assignedResourceId: 'f92ff27e-dba2-4568-a277-379219660810',
      targetQueue: 'dispatched_q',
      methodOfInspection: 'FIELD',
      taskType: {
        type: 'CLAIM_OWNER',
        friendlyName: 'Claim Owner Task',
      },
    },
  ],
  $msg: {
    externalId: 'T_1',
    sender: {
      tenantId: 'allstate',
    },
    taskReceived: '2021-12-27T11:48:54+01:00',
    claim: {
      taskId: '1234',
      lossLocation: {
        streetLine1: '123 Sample St.',
        streetLine2: '',
        city: 'Bellevue',
        state: 'WA',
        zip: '98004',
        lat: 45.08615813606878,
        lon: -123.39773680323331,
      },
      jobId: '0123456789',
      claimNumber: 'Task_1',
      insuredName: 'Joe Watson',
      catCode: '1Nn6',
      propertyType: PropertyTypeEnum.RESIDENTIAL,
      dateOfLoss: '2021-12-27T11:48:54+01:00',
      dateOfNotice: '2021-12-27T12:00:00+01:00',
      peril: 'nAOPo',
      sourcedFrom: 'sample',
      isModularHome: false,
      jobNumber: 'XO11g7Pw5W',
      supplementalData: [
        {
          key: '1',
          value: 'value1',
          label: 'label1',
          type: SupplementalDataTypes.SINGLE_LINE_TEXT,
        },
        {
          key: '2',
          value: 'value2',
          label: 'label2',
          type: SupplementalDataTypes.SINGLE_LINE_TEXT,
        },
        {
          key: '3',
          value: 'value3',
          label: 'label3',
          type: SupplementalDataTypes.SINGLE_LINE_TEXT,
        },
        {
          key: '4',
          value:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          label: 'label4',
          type: SupplementalDataTypes.MULTI_LINE_TEXT,
        },
      ],
    },
    contact: {
      primary: {
        name: 'Kyle Jones',
        phone: '800.000.0000',
        email: 'joewatson@sample.sample',
        contactMethod: 'email',
        phone2: '800.000.0000',
      },
      secondary: {
        name: 'Kyle Jones',
        phone: '800.000.0000',
        email: 'kjones@sample.sample',
        contactMethod: 'email',
        phone2: '800.000.0000',
      },
      altLocation: {
        streetLine1: '122 Sample St.',
        streetLine2: 'Suite 100',
        city: 'Bellevue',
        state: 'WA',
        zip: '98004',
      },
    },
    assignmentHandling: {
      travel: true,
      taskGroup: 'new TG',
      targetQueue: 'dispatched_q',
      templateId: 'template-123',
      durationInMinutes: 55,
      priority: PriorityLevel.MEDIUM,
      appointment: '2021-12-27T02:48:54-08:00',
      severity: '1',
      methodOfInspection: 'FIELD',
      overridePriority: true,
      mustStartBefore: '2022-06-22T11:30:00.197+02:00',
      mustStartAfter: '2022-06-22T10:00:00.197+02:00',
      mustEndBefore: '2022-06-22T12:00:00.197+02:00',
      notes: 'sample',
      preferredLanguage: 'English',
      assignmentCategory: 'assignmentCategory',
      lockOnIngress: false,
    },
    assignedResource: {
      teamId: 'team-123',
      officeId: 'office-123',
      name: 'SchedulerWrapper Test',
      firstName: 'SchedulerWrapper',
      lastName: 'Test',
      id: 'f92ff27e-dba2-4568-a277-379219660810',
    },
    attributes: [
      {
        id: 'attr_1',
        cat: Cat.PREFERRED,
        nonCat: Cat.NONE,
        useProficiency: true,
        minimumProficiency: 0,
        isPrepopulated: true,
      },
      {
        id: 'attr_2',
        cat: Cat.PREFERRED,
        nonCat: Cat.NONE,
        useProficiency: true,
        minimumProficiency: 0,
        isPrepopulated: true,
      },
    ],
  },
  $metadata: {
    appliedEfficiencyCoefficient: 0.5,
    targetQueue: 'dispatched_q',
  },
};
